<script>
import {  common } from '@/mixins/common';
import { PostApiWithAuthorizationAction } from '../../../helpers/apiActions';
// import moment from 'moment-timezone';

export default {
  name: 'SettingGeneralPage',
  components: {},
  props: {
    settingModel: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      form: {
        allowFixedRelist: false,
        allowStandardRelist: false,
        relistFixedPrice: 0,
        relistAuctionPrice: 0,
        relistLowPrice: 0,
        relistLowestPrice: 0,
        isStandardRelistFormSubmitting: false,
        isFixedRelistFormSubmitting: false
      },
      rules: {
        relistFixedPrice: [{ required: true, message: ' ', trigger: 'blur' }],
        relistAuctionPrice: [{ required: true, message: ' ', trigger: 'blur' }],
        relistLowPrice: [{ required: true, message: ' ', trigger: 'blur' }],
        relistLowestPrice: [{ required: true, message: ' ', trigger: 'blur' }],
      }
    }
  },
  mixins: [
    common
  ],
  methods: {
    setFixedRelistAsDefaultMethod () {
        let _vm = this
        if (_vm.form.allowFixedRelist) {
            _vm.form.allowStandardRelist = false
        } else {
            _vm.form.allowStandardRelist = true
        }
    },
    setStandardRelistAsDefaultMethod () {
        let _vm = this
        if (_vm.form.allowStandardRelist) {
            _vm.form.allowFixedRelist = false
        } else {
            _vm.form.allowFixedRelist = true
        }
    },
    onSubmit() {
        let _vm = this
        _vm.$refs.formGeneral.validate((valid) => {
            if (valid) {
                _vm.isFormSubmitting = true
                PostApiWithAuthorizationAction("admin/setting/general/save-product-data", _vm.form).then(() => {
                    _vm.$toast.success("Changes saved successfully.", {
                        position: "top-right",
                        timeout: 1000,
                        closeOnClick: true
                    });
                    _vm.isFormSubmitting = false
                });
            }
        });
    }
  },
  computed: {},
  mounted () {
    let _vm = this
    _vm.form = {
        allowStandardRelist: _vm.settingModel.allowFixedRelist == 0,
        allowFixedRelist: _vm.settingModel.allowFixedRelist == 1,
        relistFixedPrice: parseFloat(_vm.settingModel.relistFixedPrice),
        relistAuctionPrice: parseFloat(_vm.settingModel.relistAuctionPrice),
        relistLowPrice: parseFloat(_vm.settingModel.relistLowPrice),
        relistLowestPrice: parseFloat(_vm.settingModel.relistLowestPrice)
    }
    // eslint-disable-next-line
    console.log(_vm.form)
  }
}
</script>
<template>
    <div class="setting-general__content">
        <el-form :model="form" @submit.prevent.native="onSubmit" ref="formGeneral">
        <b-row>
        <b-col cols="4">
            <div class="box-section my-3 pb-1">
                <div class="box-section-header">STANDARD RELISTING</div>
                <div class="box-section-body py-2">
                    <label class="mb-0">Relist Auction Price</label>
                    <el-form-item
                        class="mb-2"
                        :rules="rules.relistAuctionPrice"
                        prop="relistAuctionPrice">
                        <el-input
                            v-model="form.relistAuctionPrice"
                            type="text"
                            pattern="^\d*(\.\d{0,2})?$"
                            placeholder="Relist Auction Price"
                        ></el-input>
                    </el-form-item>
                    <label class="mb-0">Relist Low Price</label>
                    <el-form-item
                        class="mb-2"
                        :rules="rules.relistLowPrice"
                        prop="relistLowPrice">
                        <el-input
                            v-model="form.relistLowPrice"
                            type="text"
                            pattern="^\d*(\.\d{0,2})?$"
                            placeholder="Relist Low Price"
                        ></el-input>
                    </el-form-item>
                    <label class="mb-0">Relist Lowest Price</label>
                    <el-form-item
                        class="mb-2"
                        :rules="rules.relistLowestPrice"
                        prop="relistLowestPrice">
                        <el-input
                            v-model="form.relistLowestPrice"
                            type="text"
                            pattern="^\d*(\.\d{0,2})?$"
                            placeholder="Relist Lowest Price"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-switch
                            v-model="form.allowStandardRelist"
                            @change="setStandardRelistAsDefaultMethod()"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch> <label>Set As Default Relisting Method</label>
                    </el-form-item>
                    <div class="text-right">
                        <b-button type="submit" variant="primary" v-if="!form.isStandardRelistFormSubmitting">
                            Update
                        </b-button>
                        <b-button type="button" variant="primary" v-else disabled>
                            <i class="el-icon-loading"></i> Processing
                        </b-button>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col cols="4">
            <div class="box-section my-3 pb-1">
                <div class="box-section-header">FIXED PRICE RELISTING</div>
                <div class="box-section-body py-2">
                    <el-form-item
                        class="mb-2"
                        :rules="rules.relistFixedPrice"
                        prop="relistFixedPrice">
                        <label class="mb-0">Fixed Relist Price</label>
                        <el-input
                            v-model="form.relistFixedPrice"
                            type="text"
                            pattern="^\d*(\.\d{0,2})?$"
                            placeholder="Fixed Relist Price"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-switch
                            v-model="form.allowFixedRelist"
                            @change="setFixedRelistAsDefaultMethod()"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch> <label>Set As Default Relisting Method</label>
                    </el-form-item>
                    <div class="text-right">
                        <b-button type="submit" variant="primary" v-if="!form.isFixedRelistFormSubmitting">
                            Update
                        </b-button>
                        <b-button type="button" variant="primary" v-else disabled>
                            <i class="el-icon-loading"></i> Processing
                        </b-button>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
        </el-form>
    </div>
</template>
<style>
.el-form-item__content {
    line-height: 18px;
}
</style>